/* ErnePazzo este JS es para desde donde se desee abrir un modal con un mapa y 1 punto seleccionado, pasando latirud, longitud, nombre, descripcion */
import bootbox from "bootbox";

export async function showMapModal(lat, lng, opts = {}) {
    const title = opts.title || 'Ubicación';
    const zoom = opts.zoom || 15;
    const markerText = opts.markerText || '';
    const markerDesc = opts.description || 'Sin descripción...';

    if (!isFinite(lat) || !isFinite(lng)) {
        bootbox.alert({
            title: title,
            message: '<p>Coordenadas inválidas</p>',
            backdrop: true,
            buttons: {
                ok: {
                    label: "",
                    className: 'ocultar',
                }
            }
        });
        return;
    }

    // cargar CSS y JS de Leaflet si no existen
    function ensureLeaflet() {
        return new Promise((resolve, reject) => {
            if (window.L) return resolve();
            // CSS
            if (!document.querySelector('link[data-leaflet]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.dataset.leaflet = '1';
                link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
                document.head.appendChild(link);
            }
            // JS
            if (!document.querySelector('script[data-leaflet]')) {
                const script = document.createElement('script');
                script.dataset.leaflet = '1';
                script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
                script.onload = () => resolve();
                script.onerror = () => reject(new Error('No se pudo cargar Leaflet'));
                document.head.appendChild(script);
            } else {
                // esperar a que esté disponible si ya se está cargando
                const check = () => {
                    if (window.L) resolve();
                    else setTimeout(check, 50);
                };
                check();
            }
        });
    }

    await ensureLeaflet();

    const mapId = `map_modal_${Date.now()}`;
    const markup = `<div id="${mapId}" style="width:100%;height:700px;"></div>`;

    const dialog = bootbox.alert({
        title: `${title}: <b>${markerText || `${lat}, ${lng}`}</b>`,
        message: markup,
        size: 'extra-large',
        backdrop: true,
        buttons: {
            ok: {
                label: "",
                className: 'ocultar',
            }
        }
    });
    $(dialog).find('.modal-footer').remove();

    // inicializar mapa cuando el DOM del modal esté disponible
    setTimeout(() => {
        try {
            const map = L.map(mapId).setView([lat, lng], zoom);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors'
            }).addTo(map);

            let myIcon = L.icon({
                iconUrl: '/pin.png',
                /*popupAnchor: [-3, -3],
                iconSize: [20, 30],*/
                iconSize: [44, 44],        // Tamaño mínimo 44x44
                iconAnchor: [22, 44],      // Punto de anclaje centrado
                popupAnchor: [0, -44]      // Posición del popup
            });

            L.marker([lat, lng], {
                draggable: false,
                icon: myIcon,
                title: 'Click para ver más detalles...',
                alt: ''
            }).addTo(map)
                .bindPopup(`<h3>${markerText}</h3>
                            <br><strong>Descripción:</strong> ${markerDesc}`);

            // corregir tamaño si es necesario
            setTimeout(() => map.invalidateSize(), 200);

            // limpiar cuando se cierre el modal
            const $dialog = $(dialog);
            $dialog.on('hidden.bs.modal', () => {
                try { map.remove(); } catch (e) { /* ignore */ }
                $dialog.off('hidden.bs.modal');
            });
        } catch (e) {
            console.error(e);
        }
    }, 50);
}

export function showDescriptionModal(title, text){
    bootbox.alert({
        title: title,
        message: `<div class='p-3' style='max-height: 80vh; overflow: auto'>${text}</div>`,
        backdrop: true,
        size: 'extra-large',
        buttons: {
            ok: {
                label: "",
                className: 'ocultar',
            }
        }
    });
}